<template>
  <div>
    <svg
      v-if="status === 'active'"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#48BEEA" />
    </svg>

    <svg
      v-else-if="status === 'done'"
      width="32"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 32 32"
    >
      <defs>
        <clipPath id="clip-path">
          <rect class="cls-1" x="4" y="4" width="24" height="24" />
        </clipPath>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <circle class="cls-2" cx="16" cy="16" r="16" />
          <g class="cls-3">
            <path
              class="cls-4"
              d="M28,16a12,12,0,1,1-3.51-8.49A12,12,0,0,1,28,16Zm-5.95-4.55a1.17,1.17,0,0,0-.38-.24,1,1,0,0,0-.44-.08,1,1,0,0,0-.44.1,1.18,1.18,0,0,0-.37.26l-5.2,6.64L12.08,15a1.21,1.21,0,0,0-.79-.3,1.13,1.13,0,0,0-1.11,1.11,1.13,1.13,0,0,0,.31.78l4,4a1.17,1.17,0,0,0,.38.24,1,1,0,0,0,.44.08,1.12,1.12,0,0,0,.44-.09,1.07,1.07,0,0,0,.36-.27l6-7.48a1.12,1.12,0,0,0,.32-.79,1.2,1.2,0,0,0-.33-.79Z"
            />
          </g>
          <g class="cls-3">
            <path
              class="cls-4"
              d="M28,16a12,12,0,1,1-3.51-8.49A12,12,0,0,1,28,16Zm-5.95-4.55a1.17,1.17,0,0,0-.38-.24,1,1,0,0,0-.44-.08,1,1,0,0,0-.44.1,1.18,1.18,0,0,0-.37.26l-5.2,6.64L12.08,15a1.21,1.21,0,0,0-.79-.3,1.13,1.13,0,0,0-1.11,1.11,1.13,1.13,0,0,0,.31.78l4,4a1.17,1.17,0,0,0,.38.24,1,1,0,0,0,.44.08,1.12,1.12,0,0,0,.44-.09,1.07,1.07,0,0,0,.36-.27l6-7.48a1.12,1.12,0,0,0,.32-.79,1.2,1.2,0,0,0-.33-.79Z"
            />
          </g>
        </g>
      </g>
    </svg>
    <svg
      v-else
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#AEB4BA" />
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    status: {
      type: String,
    },
  },
};
</script>

<style scoped>
.cls-1 {
  fill: none;
}
.cls-2 {
  fill: #101820;
}
.cls-3 {
  clip-path: url(#clip-path);
}
.cls-4 {
  fill: #fff;
}
</style>
